import { Injectable } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { MenuItem } from "../components/mainnav/menuItem";
import { SubMenuItem } from "../components/mainnav/subMenuItem";
import { UserService } from "../services/user.service";
import { Project } from "./projects/projects.service";
import { Client } from "./shared/client.service";

@Injectable()
export class NavService {
    menu = new NavProperties();
    displayBreadcrumbs: boolean = true;
    companyStyle: SafeHtml = null;

    constructor(
        private sanitizer: DomSanitizer,
        private userService: UserService
    ) {
        this.menu = NAVPROP;
    }

    setProject(summary: Project): void {
        this.menu.summary = summary;
        if (summary) {
            this.menu.title = summary.code + " : " + summary.name;
        } else {
            this.menu.title = "";
        }
    }

    setClient(client: Client): void {
        if (!this.userService.isLoggedIn) {
            this.menu.editLink = null;
        }

        this.menu.client = client;

        if (!client) {
            return;
        }

        if (client.idleTime)
            this.userService.setInactivityTimer(client.idleTime * 60);

        if (client.logoUrl) {
            this.menu.clientName = client.name;
            this.menu.companyLogo = client.logoUrl;
        } else {
            this.menu.companyLogo = "../img/PIMeo-Login.png";
        }

        var style = "";

        if (client.tertiaryColour) {
            style += `
    .nav.navbar-nav > li.active-page a {
        text-decoration-color: ${client.tertiaryColour} !important;
    }

    .breadcrumb > li:last-child > a {
        text-decoration: underline;
        text-decoration-color: ${client.tertiaryColour} !important;
    }`;
        }

        if (client.primaryColour) {
            style += `
    .navbar .pimeo-blue {
        background-color: ${client.primaryColour} !important;
        border-color: ${client.primaryColour} !important;
    }

     .card {
        border-color: ${client.primaryColour} !important;
    }

     .card .card-header.bg-primary {
        background-color: ${client.primaryColour} !important;
        border-color: ${client.primaryColour} !important;
    }

    footer.pimeo-blue {
        background-color: ${client.primaryColour} !important;
    }
`;
        }

        if (client.secondaryColour) {
            style += `
    .navbar .pimeo-blue {
        color: ${client.secondaryColour} !important;
    }

    .navbar .pimeo-blue i.glyphicon-menu-hamburger {
        color: ${client.secondaryColour} !important;
    }

    .navbar.navbar-inverse.navbar-fixed-top .navbar-header a {
        color: ${client.secondaryColour} !important;
        box-shadow: none !important;
    }

     .card .bg-primary > .card-header {
        color: ${client.secondaryColour} !important;
    }

    footer.fixed-bottom p {
        color: ${client.secondaryColour} !important;
    }`;
        }

        this.menu.companyStyle = this.sanitizer.bypassSecurityTrustHtml(
            `<style>${style}</style>`
        );
    }

    loadQSViewMenu(projectId: number): void {
        this.menu.editLink = null;
        this.menu.isinEdit = false;
        this.menu.mainMenuItems = this.getQSViewMenu(projectId);
        this.menu.topMostMenuItems = siteMenu;
        this.menu.isinEdit = false;
        this.userService
            .canAccessProject("quantity-surveying", projectId)
            .subscribe((data) => {
                if (data != null && data.activity == "Edit") {
                    this.menu.editLink = new MenuItem(
                        "qs/" + projectId + "/edit",
                        "Edit Link",
                        "divider-right"
                    );
                }
            });
    }

    loadQSEditMenu(projectId: number): void {
        this.menu.mainMenuItems = this.getQSEditMenu(projectId);
        this.menu.topMostMenuItems = siteMenu;
        this.menu.editLink = new MenuItem(
            "qs/" + projectId + "",
            "Edit Link",
            "divider-right"
        );
        this.menu.isinEdit = true;
    }

    loadQSAdminMenu(): void {
        this.menu.editLink = null;
        this.menu.isinEdit = false;
        this.menu.mainMenuItems = this.getQSAdminMenu();
        this.menu.topMostMenuItems = siteMenu;
    }

    loadEstimatingViewMenu(projectId: number): void {
        this.menu.mainMenuItems = this.getEstimatingViewMenu(projectId);
        this.menu.topMostMenuItems = siteMenu;
        this.menu.isinEdit = false;
        this.userService
            .canAccessProject("estimating", projectId)
            .subscribe((data) => {
                if (data != null && data.activity == "Edit") {
                    this.menu.editLink = new MenuItem(
                        "estimating/" + projectId + "/edit",
                        "Edit Link",
                        "divider-right"
                    );
                }
            });
    }

    loadEstimatingEditMenu(projectId: number): void {
        this.menu.mainMenuItems = this.getEstimatingEditMenu(projectId);
        this.menu.topMostMenuItems = siteMenu;
        this.menu.editLink = new MenuItem(
            "estimating/" + projectId + "",
            "Edit Link",
            "divider-right"
        );
        this.menu.isinEdit = true;
    }

    loadEstimatingAdminMenu(): void {
        this.menu.editLink = null;
        this.menu.isinEdit = false;
        this.menu.mainMenuItems = this.getEstimatingAdminMenu();
        this.menu.topMostMenuItems = siteMenu;
    }

    loadProjectsAdminView() {
        this.menu.mainMenuItems = this.getProjectsAdminView();
        this.menu.topMostMenuItems = siteMenu;
        this.menu.isinEdit = false;
    }

    async loadProjectsViewMenu(projectId: number) {
        this.menu.mainMenuItems = await this.getProjectsViewMenu(projectId);
        this.menu.isinEdit = false;
        this.menu.topMostMenuItems = siteMenu;
        this.userService
            .canAccessProject("general", projectId)
            .subscribe((data) => {
                if (data != null && data.activity == "Edit") {
                    this.menu.editLink = new MenuItem(
                        "projects/" + projectId + "/edit",
                        "Edit Link",
                        "divider-right"
                    );
                }
            });
    }

    loadProjectsEditMenu(projectId: number): void {
        this.menu.mainMenuItems = this.getProjectsEditMenu(projectId);
        this.menu.topMostMenuItems = siteMenu;
        this.menu.editLink = new MenuItem(
            "projects/" + projectId + "",
            "Edit Link",
            "divider-right"
        );
        this.menu.isinEdit = true;
    }

    loadOfflineMenu(projectId: number = null): void {
        this.menu.editLink = null;
        this.menu.isinEdit = false;
        if (projectId == null) {
            this.menu.mainMenuItems = siteMenuOffline;
            this.menu.topMostMenuItems = [];
        } else {
            this.menu.mainMenuItems = this.getProjectsViewMenuOffline(
                projectId
            );
            this.menu.topMostMenuItems = siteMenuOffline;
        }
    }

    loadQualityAssuranceAdminMenu(): void {
        this.menu.editLink = null;
        this.menu.isinEdit = false;
        this.menu.mainMenuItems = this.getQualityAssuranceAdminMenu();
        this.menu.topMostMenuItems = siteMenu;
    }

    loadHealthAndSafetyAdminMenu(): void {
        this.menu.editLink = null;
        this.menu.isinEdit = false;
        this.menu.mainMenuItems = this.getHealthAndSafetyAdminMenu();
        this.menu.topMostMenuItems = siteMenu;
    }

    setActivePage(url: string): void {
        this.resetActivePage(this.menu.mainMenuItems);
        this.resetActivePage(this.menu.topMostMenuItems);

        let activeIndex = this.findActivePageIndex(
            url,
            this.menu.mainMenuItems
        );

        if (activeIndex > -1)
            this.menu.mainMenuItems[activeIndex].isActive = true;

        activeIndex = this.findActivePageIndex(url, this.menu.topMostMenuItems);
        if (activeIndex > -1)
            this.menu.topMostMenuItems[activeIndex].isActive = true;
    }

    private resetActivePage(menuItems: MenuItem[]): void {
        for (let i = 0; i < menuItems.length; i++) {
            menuItems[i].isActive = false;
        }
    }

    private findActivePageIndex(url: string, menuItems: MenuItem[]): number {
        for (let i = 0; i < menuItems.length; i++) {
            if (url == menuItems[i].url || url == "/" + menuItems[i].url) {
                return i;
            }
        }
        return -1;
    }

    loadSettingsMenu(): void {
        this.menu.editLink = null;
        this.menu.isinEdit = false;
        this.menu.mainMenuItems = settingsMenu;
        this.menu.topMostMenuItems = siteMenu;
        this.menu.title = "";
    }

    loadMaterialMenu(): void {
        this.menu.editLink = null;
        this.menu.isinEdit = false;
        this.menu.topMostMenuItems = siteMenu;
        this.menu.mainMenuItems = materialMenu;
    }

    loadPlantMenu(): void {
        this.menu.editLink = null;
        this.menu.isinEdit = false;
        this.menu.topMostMenuItems = siteMenu;
        this.menu.mainMenuItems = plantMenu;
    }

    loadDefaultMenu(): void {
        this.menu.mainMenuItems = [];
        this.menu.editLink = null;
        this.menu.isinEdit = false;
        this.menu.topMostMenuItems = siteMenu;
        this.menu.title = "";
    }

    loadLocationsViewMenu(projectId: number): void {
        this.menu.mainMenuItems = this.getLocationsViewMenu(projectId);
        this.menu.isinEdit = false;
        this.menu.topMostMenuItems = siteMenu;
        this.userService
            .canAccessProject("location", projectId)
            .subscribe((data) => {
                if (data != null && data.activity == "Edit") {
                    this.menu.editLink = new MenuItem(
                        "locations/" + projectId + "/edit",
                        "Edit Link",
                        "divider-right"
                    );
                }
            });
    }

    loadLocationsEditMenu(projectId: number): void {
        this.menu.mainMenuItems = this.getLocationsEditMenu(projectId);
        this.menu.topMostMenuItems = siteMenu;
        this.menu.editLink = new MenuItem(
            "locations/" + projectId + "",
            "Edit Link",
            "divider-right"
        );
        this.menu.isinEdit = true;
    }

    loadUnauthorizedMenu() { }

    getProjectsAdminView() {
        return [
            new MenuItem("projects/" + "forms", "Forms", "divider-right"),
            new MenuItem(
                "projects/" + "documents",
                "Documents",
                "divider-right"
            ),
            new MenuItem(
                "projects/" + "employeehours",
                "Employee Hours",
                "divider-right"
            ),
            new MenuItem(
                "projects/" + "form-creator",
                "Form Creator",
                "divider-right"
            ),

            new MenuItem("projects/" + "form-library", "Form Library"),
        ];
    }

    async getProjectsViewMenu(projectId: number): Promise<MenuItem[]> {
        var projectAccess = await this.userService.getAllProjectAccesses("general").toPromise();

        var menuItemList = new Array(new MenuItem("projects/" + projectId, "Home", "divider-right"));
        if (projectAccess.length > 0) {
            if (projectAccess[0] <= 13)
                menuItemList.push(new MenuItem(
                    "projects/" + projectId + "/sitework",
                    "Site Work",
                    "divider-right"
                ));

            const vault = projectAccess.find(element => element == 14);
            if (vault)
                menuItemList.push(new MenuItem(
                    "projects/" + projectId + "/drawings",
                    "Vault",
                    "divider-right"
                ));
            const hs = projectAccess.find(element => element >= 15 && element <= 22);
            if (hs)
                menuItemList.push(new MenuItem(
                    "projects/" + projectId + "/health-and-safety",
                    "Health & Safety",
                    "divider-right"
                ));

            const qa = projectAccess.find(element => element >= 23 && element <= 28);
            if (qa)
                menuItemList.push(new MenuItem(
                    "projects/" + projectId + "/qa",
                    "Quality Assurance",
                    "divider-right"
                ));

            const contacts = projectAccess.find(element => element == 29);
            if (contacts)
                menuItemList.push(new MenuItem(
                    "projects/" + projectId + "/contacts",
                    "Contacts",
                    "divider-right"
                ));

            const procurement = projectAccess.find(element => element == 30 || element == 31);
            if (procurement)
                menuItemList.push(new MenuItem(
                    "projects/" + projectId + "/procurement",
                    "Procurement",
                    "divider-right"
                ));
        }

        return menuItemList;
    }

    getProjectsViewMenuOffline(projectId: number): MenuItem[] {
        return [
            new MenuItem(
                "offline/" + projectId + "/qa",
                "Quality Assurance",
                "divider-right"
            ),
            new MenuItem(
                "offline/" + projectId + "/photos",
                "Photos",
                "divider-right"
            ),
        ];
    }

    getProjectsEditMenu(projectId: number): MenuItem[] {
        return [
            new MenuItem(
                "projects/" + projectId + "/edit",
                "Edit",
                "divider-right"
            ),
            new MenuItem(
                "projects/" + projectId + "/edit/contacts",
                "Contacts",
                "divider-right"
            ),
            new MenuItem(
                "projects/" + projectId + "/edit/hourlystaff",
                "Hourly Staff",
                "divider-right"
            ),
            new MenuItem(
                "projects/" + projectId + "/edit/lookupvalues",
                "Lookup Values",
                "divider-right"
            ),
        ];
    }

    getQSViewMenu(projectId: number): MenuItem[] {
        return [
            new MenuItem("qs/" + projectId, "Home", "divider-right"),
            new MenuItem(
                "qs/" + projectId + "/drawings",
                "Vault",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/documents",
                "Documents",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/labour",
                "Allocations",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/prelims",
                "Prelims",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/subcontractors",
                "Subcontractors",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/procurement",
                "Procurement",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/projections",
                "Projections",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/financials",
                "Financials",
                "divider-right"
            ),
        ];
    }

    getQSEditMenu(projectId: number): MenuItem[] {
        return [
            new MenuItem("qs/" + projectId + "/edit", "Edit", "divider-right"),
            new MenuItem(
                "qs/" + projectId + "/edit/contacts",
                "Contacts",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/edit/management",
                "Management",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/edit/hourlystaff",
                "Hourly Staff",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/edit/allocationsheetsData",
                "Allocation Sheets",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/edit/rates",
                "Rates",
                "divider-right"
            ),
            new MenuItem(
                "qs/" + projectId + "/edit/lookupvalues",
                "Lookup Values",
                "divider-right"
            ),
        ];
    }

    getQSAdminMenu(): MenuItem[] {
        return [
            new MenuItem("qs/", "Global", "divider-right", true, [
                new SubMenuItem("qs/summary", "Global Summary"),
                new SubMenuItem("qs/global-hourly-staff", "Global Hourly Staff"),
                new SubMenuItem("qs/global-allocations", "Global Allocations")
            ]),
            new MenuItem("qs/" + "forms", "Forms", "divider-right"),
            new MenuItem("qs/documents", "Documents", "divider-right"),
            new MenuItem(
                "qs/subcontractors",
                "Subcontractors",
                "divider-right"
            ),
            new MenuItem("qs/prelims", "Prelim Suppliers", "divider-right"),
            new MenuItem(
                "qs/" + "form-creator",
                "Form Creator",
                "divider-right"
            ),
            new MenuItem("qs/lookupvalues", "Lookups", "divider-right"),
            new MenuItem("qs/settings", "Settings", "divider-right"),
            new MenuItem("qs/archive", "Archive", "divider-right"),
        ];
    }

    getEstimatingViewMenu(projectId: number): MenuItem[] {
        return [
            new MenuItem("estimating/" + projectId, "Home", "divider-right"),
            new MenuItem(
                "estimating/" + projectId + "/sitework",
                "Site Work",
                "divider-right"
            ),
            new MenuItem(
                "estimating/" + projectId + "/incoming",
                "Incoming Info",
                "divider-right"
            ),
            new MenuItem(
                "estimating/" + projectId + "/tenders",
                "Tender Submission",
                "divider-right"
            ),
        ];
    }

    getEstimatingEditMenu(projectId: number): MenuItem[] {
        return [
            new MenuItem(
                "estimating/" + projectId + "/edit",
                "Edit",
                "divider-right"
            ),
            new MenuItem(
                "estimating/" + projectId + "/edit/contacts",
                "Contacts",
                "divider-right"
            ),
            new MenuItem(
                "estimating/" + projectId + "/edit/management",
                "Management",
                "divider-right"
            ),
            new MenuItem(
                "estimating/" + projectId + "/edit/hourlystaff",
                "Hourly Staff",
                "divider-right"
            ),
            new MenuItem(
                "estimating/" + projectId + "/edit/allocationsheetsData",
                "Allocation Sheets",
                "divider-right"
            ),
            new MenuItem(
                "estimating/" + projectId + "/edit/rates",
                "Rates",
                "divider-right"
            ),
            new MenuItem(
                "estimating/" + projectId + "/edit/lookupvalues",
                "Lookup Values",
                "divider-right"
            ),
        ];
    }

    getEstimatingAdminMenu(): MenuItem[] {
        return [
            new MenuItem("estimating/", "Estimating", "divider-right"),
            new MenuItem(
                "estimating/admin/subcontractors/details",
                "Subcontractors",
                "divider-right"
            ),
            new MenuItem(
                "estimating/admin/tender",
                "Tendering Analysis",
                "divider-right"
            ),
            new MenuItem(
                "estimating/admin/documents",
                "Documents",
                "divider-right"
            ),
            new MenuItem(
                "estimating/admin/archive",
                "Archive",
                "divider-right"
            ),
        ];
    }

    getQualityAssuranceAdminMenu(): MenuItem[] {
        var baseUrl = "quality-assurance/";
        var baseClass = "divider-right";

        return [
            new MenuItem(baseUrl, "Home", baseClass),
            new MenuItem(baseUrl + "documents", "Documents", baseClass),
            //new MenuItem(baseUrl + "policies-and-guidance", "Policies & Guidance", baseClass),
            new MenuItem(baseUrl + "form-creator", "Form Creator", baseClass),
            new MenuItem(baseUrl + "form-library", "Form Library", baseClass),
            new MenuItem(baseUrl + "audits", "Audits", baseClass),
            new MenuItem(baseUrl + "inspections", "Inspections", baseClass),
            new MenuItem(baseUrl + "reports", "Reports", baseClass),
            new MenuItem(baseUrl + "meetings", "Meetings", baseClass)
            //new MenuItem(baseUrl + "news-and-alerts", "News & Alerts", baseClass),
        ];
    }

    getHealthAndSafetyAdminMenu(): MenuItem[] {
        var baseUrl = "health-and-safety/";
        var baseClass = "divider-right";

        return [
            new MenuItem(baseUrl, "Home", baseClass),
            new MenuItem(baseUrl + "documents", "Documents", baseClass),
            //new MenuItem(baseUrl + "policies-and-guidance", "Policies & Guidance", baseClass),
            new MenuItem(baseUrl + "form-creator", "Form Creator", baseClass),
            new MenuItem(baseUrl + "form-library", "Form Library", baseClass),
            new MenuItem(baseUrl + "audits", "Audits", baseClass),
            new MenuItem(baseUrl + "inductions", "Inductions", baseClass),
            new MenuItem(baseUrl + "inspections", "Inspections", baseClass),
            new MenuItem(baseUrl + "reports", "Reports", baseClass),
            new MenuItem(baseUrl + "meetings", "Meetings", baseClass),
            new MenuItem(baseUrl + "toolbox-talk", "Toolbox Talk", baseClass)
            //new MenuItem(baseUrl + "news-and-alerts", "News & Alerts", baseClass),
        ];
    }

    async getProjectQaMenu(): Promise<MenuItem[]> {
        var projectAccess = await this.userService.getAllProjectAccesses("general").toPromise();

        var projectQAMenuList = new Array();
        if (projectAccess.length > 0) {
            const documents = projectAccess.find(element => element == 23);
            if (documents)
                projectQAMenuList.push(new MenuItem("documents", "Documents"));

            const audits = projectAccess.find(element => element == 24);
            if (audits)
                projectQAMenuList.push(new MenuItem("audits", "Audits"));

            const inspections = projectAccess.find(element => element == 25);
            if (inspections)
                projectQAMenuList.push(new MenuItem("inspections", "Inspections"));

            const reports = projectAccess.find(element => element == 26);
            if (reports)
                projectQAMenuList.push(new MenuItem("reports", "Reports"));

            const meetings = projectAccess.find(element => element == 27);
            if (meetings)
                projectQAMenuList.push(new MenuItem("meetings", "Meetings"));

            const exportSettings = projectAccess.find(element => element == 28);
            if (exportSettings)
                projectQAMenuList.push(new MenuItem("export-setting", "Export Settings"));
        }

        return projectQAMenuList;
    }

    async getProjectHealthAndSafetyMenu(): Promise<MenuItem[]> {
        var projectAccess = await this.userService.getAllProjectAccesses("general").toPromise();

        var projectHSMenuList = new Array();
        if (projectAccess.length > 0) {
            const documents = projectAccess.find(element => element == 15);
            if (documents)
                projectHSMenuList.push(new MenuItem("documents", "Documents"));

            const audits = projectAccess.find(element => element == 16);
            if (audits)
                projectHSMenuList.push(new MenuItem("audits", "Audits"));

            const inductions = projectAccess.find(element => element == 17);
            if (inductions)
                projectHSMenuList.push(new MenuItem("inductions", "Inductions"));

            const inspections = projectAccess.find(element => element == 18);
            if (inspections)
                projectHSMenuList.push(new MenuItem("inspections", "Inspections"));

            const reports = projectAccess.find(element => element == 19);
            if (reports)
                projectHSMenuList.push(new MenuItem("reports", "Reports"));

            const meetings = projectAccess.find(element => element == 20);
            if (meetings)
                projectHSMenuList.push(new MenuItem("meetings", "Meetings"));

            const toolboxTalk = projectAccess.find(element => element == 21);
            if (toolboxTalk)
                projectHSMenuList.push(new MenuItem("toolbox-talk", "Toolbox Talk"));

            const exportSettings = projectAccess.find(element => element == 22);
            if (exportSettings)
                projectHSMenuList.push(new MenuItem("export-setting", "Export Settings"));
        }

        return projectHSMenuList;
    }

    getProjectFormsMenu(): MenuItem[] {
        return [
            new MenuItem("general", "General"),
            new MenuItem("meetings", "Meetings"),
        ];
    }

    getQSFormsMenu(): MenuItem[] {
        return [
            new MenuItem("general", "General"),
            new MenuItem("meetings", "Meetings"),
        ];
    }

    getSiteMenu(): MenuItem[] {
        return siteMenu;
    }

    getLocationsViewMenu(projectId: number): MenuItem[] {
        return [
            new MenuItem("locations/" + projectId, "Home", "divider-right"),
            new MenuItem(
                "locations/" + projectId + "/sitework",
                "Site Work",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/drawings",
                "Vault",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/health-and-safety",
                "Health & Safety",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/quality-assurance",
                "Quality Assurance",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/contacts",
                "Contacts",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/procurement",
                "Procurement",
                "divider-right"
            ),
        ];
    }

    getLocationsEditMenu(projectId: number): MenuItem[] {
        return [
            new MenuItem(
                "locations/" + projectId + "/edit",
                "Edit",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/edit/management",
                "Management",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/edit/contacts",
                "Contacts",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/edit/hourlystaff",
                "Hourly Staff",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/edit/allocationsheetsData",
                "Allocation Sheets",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/edit/rates",
                "Rates",
                "divider-right"
            ),
            new MenuItem(
                "locations/" + projectId + "/edit/lookupvalues",
                "Lookup Values",
                "divider-right"
            ),
        ];
    }
}

class NavProperties {
    linkState: string;
    companyLogo: string;
    clientName: string;
    topMostMenuItems: MenuItem[];
    mainMenuItems: MenuItem[];
    adminMenuItems: MenuItem[];
    editLink: MenuItem;
    isinEdit: boolean;
    summary: Project;
    title: string;
    client: Client;
    companyStyle: any;
}

const siteMenuOffline = [new MenuItem("offline", "Projects", "divider-right")];

const siteMenu = [
    new MenuItem("projects", "Projects", "divider-right"),
    new MenuItem("qs", "Quantity Surveying", "divider-right"),
    new MenuItem("estimating", "Estimating", "divider-right"),
    new MenuItem("locations", "Locations", "divider-right"),
    new MenuItem("procurement", "Plant & Material", "divider-right"),
    new MenuItem("quality-assurance", "Quality Assurance", "divider-right"),
    new MenuItem("health-and-safety", "Health & Safety", "divider-right"),
    new MenuItem("settings/employees", "Admin", "divider-right"),
];

const settingsMenu = [
    new MenuItem("settings/employees", "Employees", "divider-right"),
    new MenuItem("settings/accesses", "Accesses", "divider-right"),
    new MenuItem("settings/users", "Users", "divider-right"),
    new MenuItem("settings/organisations", "Organisations", "divider-right"),
    new MenuItem("settings/contacts", "Contacts", "divider-right"),
    new MenuItem("settings/lookupvalues", "Lookup Values", "divider-right"),
    new MenuItem("settings/codegenerator", "Code Generator", "divider-right"),
    new MenuItem("settings/settings", "Settings", "divider-right"),
];

const materialMenu = [
    new MenuItem(
        "procurement/materials/orders",
        "Global Materials Order Tracking",
        "divider-right"
    ),
    new MenuItem(
        "procurement/materials/suppliers",
        "Supplier Directory",
        "divider-right"
    ),
    new MenuItem(
        "procurement/materials/documents",
        "Material Documents",
        "divider-right"
    ),
    new MenuItem(
        "procurement/materials/admin",
        "Material Admin",
        "divider-right"
    ),
];

const plantMenu = [
    new MenuItem(
        "procurement/plant/internal-plant",
        "Internal Plant",
        "divider-right"
    ),
    new MenuItem(
        "procurement/plant/external-plant",
        "External Plant",
        "divider-right"
    ),
    new MenuItem(
        "procurement/plant/supplier-directory",
        "Supplier Directory",
        "divider-right"
    ),
    new MenuItem(
        "procurement/plant/plant-documents",
        "Plant Documents",
        "divider-right"
    ),
    new MenuItem(
        "procurement/plant/plant-admin",
        "Plant Admin",
        "divider-right"
    ),
];

const NAVPROP: NavProperties = {
    linkState: "active",
    topMostMenuItems: siteMenu,
    mainMenuItems: [],
    editLink: null,
    isinEdit: false,
    adminMenuItems: settingsMenu,
    companyLogo: "",
    clientName: "",
    title: "",
    summary: new Project(),
    client: null,
    companyStyle: null,
};
